import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Check if the user has seen the modal already in this session
    const hasSeenModal = sessionStorage.getItem("hasSeenWelcomeModal")

    // If they haven't seen it, show the modal after a short delay
    if (!hasSeenModal) {
      setTimeout(() => {
        this.open()
      }, 1500) // Show after 1.5 seconds
    }

    // Add event listener for scroll to enhance navbar
    this.setupStickyNavbar()
  }

  setupStickyNavbar() {
    const navbar = document.getElementById('main-navbar')
    if (!navbar) return

    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        navbar.classList.add('shadow-md')
        navbar.classList.remove('shadow-sm')
      } else {
        navbar.classList.remove('shadow-md')
        navbar.classList.add('shadow-sm')
      }
    })
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden") // Prevent scrolling
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden") // Re-enable scrolling
    // Mark as seen for this session when closed
    sessionStorage.setItem("hasSeenWelcomeModal", "true")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  setDoNotShow(event) {
    if (event.target.checked) {
      sessionStorage.setItem("hasSeenWelcomeModal", "true")
    } else {
      sessionStorage.removeItem("hasSeenWelcomeModal")
    }
  }
}
